import { render, staticRenderFns } from "./PhpGist.vue?vue&type=template&id=44c1eaea&scoped=true&"
import script from "./PhpGist.vue?vue&type=script&lang=js&"
export * from "./PhpGist.vue?vue&type=script&lang=js&"
import style0 from "./PhpGist.vue?vue&type=style&index=0&id=44c1eaea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c1eaea",
  null
  
)

export default component.exports